
export const baseUrl = 'https://api-fluid.quixlab.in';
export const headers = {
    "Content-type": "application/json; charset=UTF-8"
};
